import styled from 'styled-components';
import { Wrapper, WrapperProps } from '../../../Wrapper/Wrapper';

interface CheckboxProps extends WrapperProps {
  isSelected;
}

export const Checkbox = styled(Wrapper)<CheckboxProps>(({ theme, isSelected }) => ({
  display: 'flex',
  position: 'relative',
  width: 16,
  height: 16,
  background: isSelected ? theme.colors.primary['500'] : theme.colors.bg,
  boxShadow: isSelected ? 'none' : 'inset 0px 2px 4px rgba(55, 65, 81, 0.06)',
  border: `1px solid ${isSelected ? theme.colors.primary['500'] : theme.colors.neutral['300']}`,
  borderRadius: theme.radii.medium,
  boxSizing: 'border-box',
  flexShrink: 0,

  '&::after': {
    opacity: isSelected ? 1 : 0,
    position: 'absolute',
    fontFamily: "'Font Awesome 5 Pro'",
    content: "'\f00c'",
    fontWeight: 900,
    color: theme.colors.bg,
    fontSize: 10,
    top: 2,
    left: 2,
  },
}));
